// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaIndexListQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  filter?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
}>;

export type SchemaIndexListQuery = {
  __typename?: "GraphqlQuery";
  getSchemaIndices: Array<{
    __typename?: "SchemaIndex";
    id: string;
    name: string;
    tableName: string;
    sizeBytes?: number | null;
    writeOverhead?: number | null;
    scansPerMin?: number | null;
    lastUsedAt?: string | null;
    issues?: Array<{
      __typename?: "Issue";
      id: string;
      state: string;
      description: string;
      severity: string;
      references: Array<{ __typename?: "IssueReference"; name: string }>;
    } | null> | null;
  }>;
};

export const SchemaIndexListDocument = gql`
  query SchemaIndexList(
    $databaseId: ID!
    $offset: Int
    $limit: Int
    $filter: String
    $sortBy: String
    $sortDirection: SortDirection
  ) {
    getSchemaIndices(
      databaseId: $databaseId
      offset: $offset
      limit: $limit
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      id
      name
      tableName
      sizeBytes
      writeOverhead
      scansPerMin
      lastUsedAt
      issues {
        id
        state
        description
        severity
        references {
          name
        }
      }
    }
  }
`;

/**
 * __useSchemaIndexListQuery__
 *
 * To run a query within a React component, call `useSchemaIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaIndexListQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useSchemaIndexListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaIndexListQuery,
    SchemaIndexListQueryVariables
  > &
    (
      | { variables: SchemaIndexListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SchemaIndexListQuery, SchemaIndexListQueryVariables>(
    SchemaIndexListDocument,
    options,
  );
}
export function useSchemaIndexListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaIndexListQuery,
    SchemaIndexListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaIndexListQuery,
    SchemaIndexListQueryVariables
  >(SchemaIndexListDocument, options);
}
// @ts-ignore
export function useSchemaIndexListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaIndexListQuery,
    SchemaIndexListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaIndexListQuery,
  SchemaIndexListQueryVariables
>;
export function useSchemaIndexListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaIndexListQuery,
        SchemaIndexListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaIndexListQuery | undefined,
  SchemaIndexListQueryVariables
>;
export function useSchemaIndexListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaIndexListQuery,
        SchemaIndexListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaIndexListQuery,
    SchemaIndexListQueryVariables
  >(SchemaIndexListDocument, options);
}
export type SchemaIndexListQueryHookResult = ReturnType<
  typeof useSchemaIndexListQuery
>;
export type SchemaIndexListLazyQueryHookResult = ReturnType<
  typeof useSchemaIndexListLazyQuery
>;
export type SchemaIndexListSuspenseQueryHookResult = ReturnType<
  typeof useSchemaIndexListSuspenseQuery
>;
export type SchemaIndexListQueryResult = Apollo.QueryResult<
  SchemaIndexListQuery,
  SchemaIndexListQueryVariables
>;
